var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.1999 2.4C6.53716 2.4 5.9999 2.93726 5.9999 3.6V4.8H4.7999C3.47442 4.8 2.3999 5.87452 2.3999 7.2V19.2C2.3999 20.5255 3.47442 21.6 4.7999 21.6H19.1999C20.5254 21.6 21.5999 20.5255 21.5999 19.2V7.2C21.5999 5.87452 20.5254 4.8 19.1999 4.8H17.9999V3.6C17.9999 2.93726 17.4626 2.4 16.7999 2.4C16.1372 2.4 15.5999 2.93726 15.5999 3.6V4.8H8.3999V3.6C8.3999 2.93726 7.86264 2.4 7.1999 2.4ZM7.1999 8.4C6.53716 8.4 5.9999 8.93726 5.9999 9.6C5.9999 10.2627 6.53716 10.8 7.1999 10.8H16.7999C17.4626 10.8 17.9999 10.2627 17.9999 9.6C17.9999 8.93726 17.4626 8.4 16.7999 8.4H7.1999Z",
    fill: "#3EB0CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.e40275407153977b6c6ff05eff0c03ab.svg";
export { ForwardRef as ReactComponent };